<template>
  <div style="overflow-x: hidden">
    <el-row :gutter="10" style="overflow-x: hidden">
      <el-col :span="6" style="padding: 20px">
        <el-card class="header_card" style="height: 191px;">
          <div slot="header">
            <span v-if="this.$route.query.flag == 'view'">查看成员</span>
            <span v-if="this.$route.query.flag == 'add'">新增成员</span>
            <span v-if="this.$route.query.flag == 'update'">修改成员</span>
          </div>
          <div style="height: 143px">
            <el-scrollbar style="height: 100%;" ref="scrollbar">
            <span v-if="eimsUser">
            <el-form>
              <el-row>
                <el-col>
                  <el-form-item label="姓名：" >
                    <basic-info-detail :code-value="form.name"></basic-info-detail>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="手机：" style="margin-top: -30px">
                    <basic-info-detail :code-value="form.userId"></basic-info-detail>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="机构：" style="margin-top: -30px">
                    <basic-info-detail :code-value="deptName"></basic-info-detail>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </span>
            </el-scrollbar>
          </div>

        </el-card>

        <el-card class="user-menu-item-card" style="margin-top: 10px;" :style="userMenuItemCardStyle">
<!--          <el-scrollbar style="height: 100%;" ref="scrollbar">-->
            <el-row :gutter="10" class="" style="">
              <el-col :span="12" v-for="(item,index) in userMenuItemList" :key="index">
                <div class="user-menu-item" :style="{'color':index==userMenuItemIndex?'#5ed5d9':'','fontWeight': index==userMenuItemIndex?'bolder':''}" @click="handleTabClick(index, item.path)">{{item.name}}</div>
              </el-col>
            </el-row>
<!--          </el-scrollbar>-->
        </el-card>

        <el-card class="button-group" style="margin-top: 10px;text-align: center;">
          <div>
            <el-row>
              <el-col :span="7" style="float:left;text-align: left;padding-left: 10px">
                <span v-if="userMenuItemIndex<=0">&nbsp;</span>
                <a size="small" @click="userMenuItemIndex=userMenuItemIndex-1" v-if="userMenuItemIndex>0"><&nbsp;{{userMenuItemList[userMenuItemIndex-1].name}}</a>
              </el-col>
              <el-col :span="5" style="text-align: center;">
                <el-button type="info" size="small"  @click="handleCancelClick" >返回</el-button>
              </el-col>
              <el-col :span="5" style="text-align: center;">
                <el-button type="primary" size="small" v-show="this.$route.query.flag != 'view'" @click="handleCommitClick">保存</el-button>
              </el-col>
              <el-col :span="7" style="float: right;text-align: right;padding-right: 10px">
                <a size="small" @click="userMenuItemIndex=userMenuItemIndex+1" v-if="userMenuItemIndex<userMenuItemList.length-1">{{userMenuItemList[userMenuItemIndex+1].name}}&nbsp;></a>
                <span v-if="userMenuItemIndex>=userMenuItemList.length-1">&nbsp;</span>
              </el-col>
            </el-row>
          </div>
        </el-card>

      </el-col>
      <el-col :span="18" style="height: 100%; padding: 20px">
        <router-view ref="child" @childClick="childClick" v-if="loadingData"></router-view>
      </el-col>
    </el-row>
    <animation :loadingDataVisible="loadingDataVisible" :loadingText="'Loading'"></animation>
  </div>

</template>

<script>
    import animation from "@/components/loading/animation";
    import BasicViewInfo from "../../components/member/BasicViewInfo";
    import {getCascaderFullValue} from '@/utils/cascader';
    import BasicInfoDetail from "@/components/member/BasicInfoDetail";
    import {Message} from "element-ui";
    import {mapState} from "vuex";
    import http from "@/utils/axios";
    import cookie from "@/utils/cookie";

    export default {
        name: "MemberAdd",
        components: {
            BasicViewInfo,
            animation,
            BasicInfoDetail,
        },
        data() {
            return {
                elementDeptId:[],
                loadingData: true,
                activePath: '/user/info/basic',
                currPath: '',
                nextPath: '',
                loadingDataVisible: false,
                userMenuItemCardStyle: {
                  height: ''
                },
                userMenuItemList:[
                    {path: '/user/info/basic', name: '基本信息'},
                    {path: '/user/info/paper', name: '论文'},
                    {path: '/user/info/work', name: '著作'},
                    {path: '/user/info/patent', name: '专利'},
                    {path: '/user/info/achi', name: '成果转化'},
                    {path: '/user/info/subject', name: '课题'},
                    {path: '/user/info/teaching', name: '医教类项目'},
                    {path: '/user/info/gcp', name: 'Gcp'},
                    {path: '/user/info/award', name: '成果奖励'},
                    {path: '/user/info/honor', name: '荣誉称号'},
                    {path: '/user/info/talent', name: '人才培养'},
                    {path: '/user/info/teacher', name: '跟师名单'},
                    {path: '/user/info/appointment', name: '社会任职'},
                    {path: '/user/info/study', name: '外出进修'},
                    {path: '/user/info/graduate', name: '研究生'},
                    {path: '/user/info/meeting', name: '主办学术会议'},
                    {path: '/user/info/training', name: '承办专科培训'},
                    {path: '/user/info/lecture', name: '受邀学术讲座'},
                    {path: '/user/info/volunteer', name: '扶贫挂职义诊'},
                    {path: '/user/info/studio', name: '名医工作室'},
                    {path: '/user/info/guide', name: '指南'},
                    {path: '/user/info/center', name: '基地/中心'},
                    {path: '/user/info/alliance', name: '联盟'},
                    {path: '/user/info/article', name: '科普文章'},
                    {path: '/user/info/lecture2', name: '科普讲座'},
                    {path: '/user/info/quality', name: '教学质量工程'}
                ],
                userMenuItemIndex: 0,
                form:{
                  userId:'',
                  name:'',
                  majorDepartId:'',
                },
                departments: [],
                editSelf:"0",
            };
        },

        mounted() {
          window.addEventListener('resize', this.getHeight);
          this.getHeight();
          this.setUserMenuItemIndex(this.$route.path)
          if (this.$route.query.flag != 'view') {
            window.onbeforeunload = () =>{
              // 此处调用保存的方法
              return 'tips'
            }
          }

        },

        destroyed() {
            //清除浏览器刷新弹窗
            window.onbeforeunload = null
            window.removeEventListener('resize', this.getHeight);
        },
        watch:{
            userMenuItemIndex(newVal){
                let path = this.userMenuItemList[newVal].path;
                this.handleTabClick(newVal, path);
            }
        },

        methods: {

          // 设置刷新之后可以显示不选中基本信息
          setUserMenuItemIndex(path){
            for (let i = 0; i < this.userMenuItemList.length; i++) {
              let item = this.userMenuItemList[i]
              if (item.path == path) {
                this.userMenuItemIndex = i
                return
              }
            }
          },

          //设置自适应高度
          getHeight() {
            this.userMenuItemCardStyle.height = window.innerHeight - 388 + 'px';
          },

          //查询部门id
          getDepartments(){
            let token = cookie.getCookie("token");
            http.post(window.config.api.baseUrl + '/eims-api/department/findCurrentAndSub', {
              token: token,
              data: {
                pageSize: -1
              }
            }).then(response => {
              this.departments = response.data.data.departments;
              //计算出医院的全id路径
              if (this.form.majorDepartId){
                let departIds = getCascaderFullValue(this.departments,this.form.majorDepartId);
                this.elementDeptId=departIds
              }

            })
          },

            //接收子路由传来的值
            childClick(e) {
                this.handleTabClick(e);
                this.activePath = e;

            },

            beforeTabLeave(activeName, oldActiveName) {
                if (!this.nextPath) {
                    this.currPath = oldActiveName;
                    this.nextPath = activeName;
                } else {
                    this.nextPath = '';
                }
            },

            handleTabClick(index, path) {
                this.userMenuItemIndex = index;
                if (this.$route.query.path == '/user/approve') {
                    this.$router.push({path: path, query: {"flag": this.$route.query.flag, path: '/user/approve'}})
                } else {
                    this.$nextTick(() => {
                        // 这里要注意判断 有的子路由没有validateFileForm()这个方法的话会报错
                        if (this.$refs.child && this.$refs.child.validateFileForm()) {
                          if(this.$route.query.isSelf=='1'){
                            this.$router.push({
                              path: path,
                              query: {"flag": this.$route.query.flag, "userId": this.$route.query.userId,isSelf:1}
                            })
                          }else {
                            this.$router.push({
                              path: path,
                              query: {"flag": this.$route.query.flag, "userId": this.$route.query.userId}
                            })

                          }

                        } else {
                            this.currPath ? this.activePath = this.currPath : '';
                            this.currPath = '';
                        }
                    })
                }
            },
          handleCancelClick(){

            if (this.$route.query.isSelf ){
              if (this.$route.query.flag == "update"){
                this.$router.push({path: '/myself/info/update'})
              }else if (this.$route.query.flag == "view"){
                this.$router.push({path: '/myself/info/view'})
              }
            } else {
              if (this.$route.query.path == '/user/approve') {
                this.$router.push({path:'/user/approve'});
              }else {
                this.$router.push({path:'/user/list'});
            }
            }


          },
          handleCommitClick(param){
            let that = this;
            if (that.$refs.child && !that.$refs.child.validateFileForm()){
              return false;
            }
            that.$refs.child.commitEimsUserBasic();
            //将页面信息存到modules中
            // that.$store.dispatch("getWorksInfo", {"eimsUserInfWorks": that.data.allData,"userId": that.userId});

            //提交数据
            if (this.userMenuItemList[this.userMenuItemIndex].path != '/user/info/basic') {
              let flag = 'UPDATE';
              let editSelf = this.editSelf;
              //如果userModule中的userId有值，则创建用户变成修改用户
              if(that.userUserId){
                flag = "UPDATE"
              }
              //userModule中的userId没有值或者userModule中userId值等于输入框中的userId值，方可调用接口
              if (!that.userUserId || that.userUserId == that.form.userId){
                that.$store.dispatch("updateOrInsertMemberInfo",{flag,editSelf}).then(value => {
                  if(value.data.code == '00000'){
                    if (this.$route.query.flag == "add"){
                      Message.success({message:"创建用户成功", showClose: true});
                    }else if(this.$route.query.flag == "update"){
                      Message.success({message:"修改用户成功", showClose: true});
                    }
                    if (this.$route.query.isSelf && this.$route.query.flag == "update"){
                      this.$router.push({path: '/myself/info/update'})
                    } else{
                      this.$router.push({path:'/user/list'});
                    }
                    this.$store.dispatch("getEimsUser",{"userId": this.userId})
                  }

                })
              }
            }



          },
        },

        created() {
            if (this.$route.query.isSelf == "1") {
                let flag = "1";
                this.editSelf = "1"
                this.loadingData = false;
                this.loadingDataVisible = true;
                this.$store.dispatch("findMySelfInfo", {flag}).then(response => {
                    this.loadingData = true;
                }).finally(() => {
                    this.loadingDataVisible = false;
                    if (this.eimsUser && this.eimsUser.userId){
                      this.form.userId = this.eimsUser.userId;
                      this.form.name = this.eimsUser.name;
                      this.form.majorDepartId = this.eimsUser.majorDepartId;
                    }
                    this.getDepartments();
                });
            }else if (this.$route.query.flag == "update" || this.$route.query.flag == "view") {
                let userId = this.$route.query.userId;
                //管理审核进入查看于自己查看得标识    '1'
                let flag = this.$route.query.checkFlag;
                this.loadingData = false;
                this.loadingDataVisible = true;
                this.$store.dispatch("findMemberInfo", {userId, flag}).then(response => {
                    this.loadingData = true;
                }).finally(() => {
                    this.loadingDataVisible = false;
                    if (this.eimsUser && this.eimsUser.userId){
                      this.form.userId = this.eimsUser.userId;
                      this.form.name = this.eimsUser.name;
                      this.form.majorDepartId = this.eimsUser.majorDepartId;
                    }
                    this.getDepartments();
                });
            }
        },

        computed:{
          //获取部门名
          deptName: function () {
            let deptName = "";
            if (this.elementDeptId.length == 1){
              deptName = this.departments[0].label
            }
            if (this.elementDeptId.length == 2){
              let list = this.departments[0].children;
              list.forEach((arr,index) => {
                if (arr.value == this.elementDeptId[1]){
                  deptName = arr.label;
                }
              })
            }
            if (this.elementDeptId.length == 3){
              let list = this.departments[0].children;
              list.forEach((arr) => {
                if (arr.value == this.elementDeptId[1]){
                  let list1 = arr.children;
                  list1.forEach((arr1) => {
                    if(arr1.value == this.elementDeptId[2]){
                      deptName = arr1.label
                    }
                  })
                }
              })
            }
            return deptName
          },
            ...mapState({
                stateElementDeptId:state => state.elementDeptId,
                eimsUser: state => state.basicInfoModule.eimsUser,
                eimsUserInfoBase: state => state.basicInfoModule.eimsUserInfoBase,
                userUserId: state => state.userModule.userId,
                codesTree: state => state.codeDictModule.codesTree,
                response:state => state.memberAllInfoModule.response,
                currUserDeptIdCache: state => state.headerStore.currUserDeptIdCache,
            })
        }
    }
</script>


<style scoped>
  /*/deep/ .el-card__body, .el-main{*/
  /*  padding-bottom: 0px;*/
  /*}*/

  .el-row .el-card {
    min-width: 100%;
    height: 100%;
    margin-right: 20px;
    transition: all .5s;
  }

  /deep/ .user-menu-item-card .el-card__body {
    /*overflow-y: scroll;*/
    height: 100%;
    width: 100% !important;
    overflow-x: hidden !important;
  }

  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden !important;
    top: auto !important;
  }

  /deep/ .el-tabs__nav-wrap::after {
    content: none;
  }

  /*点击节点时字体颜色*/
  /deep/ .el-tabs__item.is-active {
    color: #5ddddc;
  }

  /deep/ .el-tabs__item:hover {
    color: #5ddddc !important;
  }

  /*点击节点是底部横线颜色*/
  /deep/ .el-tabs__active-bar {
    background-color: #5ddddc;
  }

  .user-menu-item {
    cursor: pointer;
    /*font-weight: bolder;*/
    line-height: 2;
    color: #6c6c6c;
    font-size: 14px;
  }

  .user-menu-item:hover {
    color: #5ed5d9;
    font-weight: bolder;
  }

  /deep/ .button-group .el-card__body{
    height: 42px;
    padding: 5px;
  }

  .button-group a{
    display: block;
    line-height: 32px;
    cursor: pointer;
    font-size: 12px;
    color: #5ed5d9;
  }
  .header_card{
    /*margin: 20px;*/
  }
  .user-menu-item-card{
    /*margin: 20px;*/
  }
  .button-group{
    /*margin: 20px;*/
  }
  /deep/ .header_card .el-card__body{
    height: 133px;
    margin-top: -10px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/member/CreateMember.vue